import { render, staticRenderFns } from "./OrderDirections.vue?vue&type=template&id=c89ab5ca&scoped=true&"
import script from "./OrderDirections.vue?vue&type=script&lang=js&"
export * from "./OrderDirections.vue?vue&type=script&lang=js&"
import style0 from "./OrderDirections.vue?vue&type=style&index=0&id=c89ab5ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89ab5ca",
  null
  
)

export default component.exports